import { Button } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { StepPage } from "../../components/StepPage";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import { ReviewServices } from "../ReviewServices/ReviewServices";
import { jsx as _jsx } from "react/jsx-runtime";
export const {
  ReviewServicesStepTestIds
} = getTestIds();
export default function ReviewServicesStep(_ref) {
  let {
    selectedBundleID,
    selectedOptionalServices,
    onDone,
    onBack,
    setSelectedOptionalServices
  } = _ref;
  const {
    MULTIPLE_LEGAL_TERMS_DOCUMENTS
  } = useFeatureFlags();
  const {
    relationship,
    isPreview,
    isFromDraft
  } = useCobConfig();
  return /*#__PURE__*/_jsx(StepPage, {
    header: getStepName(COBStep.reviewServices, relationship, Boolean(MULTIPLE_LEGAL_TERMS_DOCUMENTS)),
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      "data-testid": relationship.isSample ? ReviewServicesStepTestIds.TestAgreementPrimaryNextButton() : ReviewServicesStepTestIds.PrimaryNextButton(),
      onClick: () => {
        onDone();
      },
      children: 'Next'
    }),
    onBackBtnClick: onBack,
    dataTestId: ReviewServicesStepTestIds.Root(),
    children: /*#__PURE__*/_jsx(ReviewServices, {
      isPreview: isPreview,
      relationship: relationship,
      selectedBundleID: selectedBundleID,
      selectedOptionalServices: selectedOptionalServices,
      setSelectedOptionalServices: setSelectedOptionalServices,
      isFromDraft: isFromDraft
    })
  });
}